import { ICON_SIZE } from '@components/v2/constants';
import ListItemIcon from '@components/v2/ui/List/ListItemIcon';
import Loading from '@components/v2/ui/Loading/Loading';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import React, { useState } from 'react';

type MoreActionsMenuItemProps = {
  onClickMenuItem: () => Promise<void>;
  label: string;
  icon: React.ReactNode;
  setAnchorEl: (event: React.MouseEvent<HTMLButtonElement> | null) => void;
  testId: string;
};

const MoreActionsMenuItem = ({
  onClickMenuItem,
  label,
  icon,
  setAnchorEl,
  testId,
}: MoreActionsMenuItemProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleOnClick = async () => {
    setIsLoading(true);
    await onClickMenuItem();
    setAnchorEl(null);
    setIsLoading(false);
  };

  return (
    <MenuItem sx={{ minHeight: 'auto' }} testId={testId} onClick={handleOnClick}>
      <ListItemIcon>{isLoading ? <Loading size={ICON_SIZE.md} /> : icon}</ListItemIcon>
      {label}
    </MenuItem>
  );
};

export default MoreActionsMenuItem;
